import moment from 'moment';

const ISOFormat = (data?: moment.MomentInput): string => moment(data).toISOString();

export default ISOFormat;
